module.exports = __webpack_public_path__ + "static/aus_logo_white-18cdec386716925ea6419238cf691bde.png";